import React from 'react';

export default function VisistProductBanner({
  productName = 'SmartAssessment', // 'SmartAssessment' | 'SmartJournal'
  height = 'h-56',
  className = ''
}) {
  const isJournal = productName === 'SmartJournal';
  const imageSrc = isJournal ? '/assets/SJ.png' : '/assets/SA.png';
  const altText = isJournal ? 'VISIST SmartJournal' : 'VISIST SmartAssessment';

  return (
    <div className={`relative w-full ${height} bg-[#050505] rounded-t-[2.5rem] border-b border-white/10 overflow-hidden flex items-center justify-center p-4 select-none ${className}`}>
      {/* Background Subtle Glow */}
      <div className="absolute inset-0 bg-gradient-to-b from-emerald-500/10 via-transparent to-transparent opacity-30 pointer-events-none" />
      
      {/* Image Banner from public/assets */}
      <img
        src={imageSrc}
        alt={altText}
        className="w-full h-full object-contain p-2 transform transition-transform duration-500 group-hover:scale-105"
      />
    </div>
  );
}
